import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ValidationErrors, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { CountryService } from '../../shared/services/country.service';
import { ZipCodeService } from '../../shared/services/zip-code.service';
import { map, startWith, delay } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
export class Country {
  code: string;
  name: string;
    public toString = () : string => {
        return `Foo (id: ${this.name})`;
    }
}


@Component({
  selector: 'app-contact-edit',
  templateUrl: './contact-edit.component.html',
  styleUrls: ['./contact-edit.component.scss'],
  providers: [ MessageService ]
})
export class ContactEditComponent implements OnInit, OnChanges {

  @Input() contact: any;

  @Output() cancel: EventEmitter<any> = new EventEmitter();
  @Output() save: EventEmitter<any> = new EventEmitter();

  form: FormGroup;
  filteredCountries: Observable<Country[]>;
  countries: Country[] = [];
  localities: any[] = [];

  constructor(private fb: FormBuilder,
  		private zipCodeService: ZipCodeService,
  	private countryService: CountryService,
    private messageService: MessageService
  	) { }

  ngOnInit() {
  	this._buildForm();
  	this.countryService.get().subscribe(data => this.countries = data);
    this.filteredCountries = this.form.controls.country.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this._filterCountries(country) : this.countries.slice())
      );      	

	this.form.controls.zip_code.valueChanges.subscribe(v => { 
		this.zipCodeService.get(v).subscribe(data => {
			this.localities = data;
			if (data && data.length == 1) {
				this.form.controls.locality.patchValue(data[0].name);
			}
		});
	});  	

  }


  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.contact && changes.contact.currentValue && changes.contact.currentValue.errors ) {
      if (Array.isArray(changes.contact.currentValue.errors)) {
        changes.contact.currentValue.errors.map(e => {
          this.form.controls[e.field].setErrors({'backend': e.message});
        });
      } else {
        console.log("messageservice", changes.contact.currentValue.errors);
        this.messageService.add({severity:'error', summary: 'Erreur', detail: changes.contact.currentValue.errors});
      }

    }
  }  


  onCancel() {
  	this.cancel.emit();
  }

  onSave() {
  	let c = Object.assign(this.contact, this.form.value);
    c.full_country = c.country;
    c.country = c.full_country && c.full_country.code;
  	this.save.emit(c);
  }

  _buildForm() {
 	this.form = this.fb.group({
 		'name': [ this.contact.name, [ Validators.required ] ],
 		'name2': [ this.contact.name2, [] ],
 		'street': [ this.contact.street, [] ],
        'zip_code' : new FormControl(this.contact.zip_code, {
   						validators: Validators.required,
   						updateOn: 'blur'
				}),
       	'locality': [ this.contact.locality, [] ],
       	'country': [ this.contact.full_country , [] ],
    'phone': [ this.contact.phone, [] ],
    'gsm': [ this.contact.gsm, [] ],
    'email': [ this.contact.email, [] ],
    'vat': [ this.contact.vat, [] ],
    'bce': [ this.contact.bce, [] ],
    });  	
  }

  private _filterCountries(value: string): Country[] {
    const filterValue = value ? value.toString().toLowerCase() : '';
    return this.countries.filter(country => country.name.toLowerCase().indexOf(filterValue) === 0);
  }
	displayFn(user?: Country): string | undefined {
    return user ? user.name : undefined;
  }
}
